/**
 * side-nav.js
 *
 * Handles toggling the navigation menu for small screens.
 * Also adds a focus class to parent li's for accessibility.
 * Finally adds a class required to reveal the search in the handheld
 * footer bar.
 */
( function( $ ) {

    let subPageMenu, toggler;

    subPageMenu = $( ".page-sidebar" );
    toggler     = $( ".page-sidebar__title" );

    window.addEventListener('resize', function(){

        if( window.innerWidth > 900 ) {
            subPageMenu.removeClass('page-sidebar--hide');
        }

        if( window.innerWidth < 900 ) {
            subPageMenu.addClass('page-sidebar--hide');
        }

    });

    toggler.on( 'click', function( event ) {

      if( window.innerWidth < 900 && document.body.classList.contains( 'js-active' ) ) {
        event.preventDefault();
        subPageMenu.toggleClass('page-sidebar--hide');
      }

    });


} )( jQuery );